module.exports = __webpack_public_path__ + "static/media/Icon_Transportify_White.b856ba8d.svg";